<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal()">
    <div class="modal dialog-history" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">История сообщений</h3>
        <div class="close" @click.stop="closeModal()">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row dialog-history__controls-wrap">
          <div class="page__item dialog-history__search">
            <SearchForm :value="state.searchValue" @form-submit="setSearchValue" />
          </div>
          <div class="page__item">
            <AppInputDate :value="state.filterDate"
                          :width="mediaBreakPoint !== 'desktop' ? '100%' : '184px'"
                          @value-changed="setFilterDate"
            />
          </div>
          <div class="page__item">
            <AppButton title="Сбросить"
                       type="alt"
                       width="100px"
                       @click.native="clearFilter"
            />
          </div>
        </div>
        <div class="dialog-history__messages-wrap custom-scrollbar">
          <transition name="fade" mode="out-in">
            <div class="message-list" v-if="state.messages.length !== 0">
              <transition-group name="fade">
                <div class="message-list__item" v-for="item in state.messages" :key="item.id">
                  <!-- в массив сообщений помещается отбивка по дате (во время записи в стейт) -->
                  <div class="date" v-if="item.is_dateBreaker">
                    <h4 class="date__h">{{ dateBreakerText(item.date) }}</h4>
                  </div>
                  <DialogMessage v-else
                                 :message="item"
                                 history-mode
                  />
                </div>
              </transition-group>
            </div>
            <div class="dialog-history__preloader" v-if="state.isLoading && state.messages.length === 0">
              <ThePagePreloader position="component"/>
            </div>
            <div class="dialog-history__no-records" v-if="!state.isLoading && state.messages.length === 0">
              <AppNoRecordsPlaceholder  text="Сообщений не найдено" />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SearchForm from '@/components/page/input/SearchForm'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import DialogMessage from '@/components/page/widget/DialogMessage'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import { currentDate, formatDate } from '@/utils/utils'
import AppButton from '@/components/page/button/AppButton'
export default {
  name: 'dialog-history-modal',
  components: { AppButton, ThePagePreloader, DialogMessage, AppNoRecordsPlaceholder, AppInputDate, SearchForm },
  props: {
    state: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
    mediaBreakPoint () {
      return this.$store.getters.getMediaBreakpoint
    }
  },
  methods: {
    closeModal () {
      this.$emit('close-modal')
    },
    setSearchValue (value) {
      this.$store.commit('SET_DIALOG_HISTORY_MODAL_SEARCH_VALUE', value)
    },
    setFilterDate (date) {
      this.$store.commit('SET_DIALOG_HISTORY_MODAL_FILTER_DATE', date)
    },
    clearFilter () {
      this.$store.commit('CLEAR_DIALOG_HISTORY_MODAL_FILTER')
    },
    dateBreakerText (date) {
      const compareDateA = new Date(currentDate())
      const compareDateB = new Date(date.slice(0, 10))
      // сравнение без преобразования к toDateString() всегда возвращала false
      return compareDateA.toDateString() === compareDateB.toDateString() ? 'Сегодня' : formatDate(date)
    }
  },
  mounted () {
    this.$store.dispatch('loadDialogHistoryModalMessages')
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
}

.modal {
  position: absolute;
  top: 5%;
  left: 5%;
  width: 90%;
  height: 90%;

  @media screen and (max-width: $tablet_start) {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    overflow: hidden;

    @media screen and (max-width: $tablet_start) {
      padding: 0 10px 20px;
    }
  }
}

.page__item {
  @media screen and (max-width: $tablet_start) {
    width: 100%;
    max-width: 400px;
  }
}

.dialog-history {
  &__search {
    flex: 1;

    @media screen and (max-width: $tablet_start) {
      flex: 0;
    }
  }

  &__controls-wrap {
    @media screen and (max-width: $tablet_start) {
      flex: 0;
      display: block;
    }
  }

  &__messages-wrap {
    position: relative;
    height: 100%;
    overflow: auto;

    @media screen and (max-width: $tablet_start) {
      padding-right: 10px;
    }
  }

  &__no-records {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .message {
    // полностью отступ убрать нельзя, обводка аватарке выпадает за границы блоки и обрезается
    margin-left: 2px;
  }
}

.date {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  color: $color_second;
  margin-bottom: 34px;

  &__h {
    position: relative;
    z-index: 2;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 108px;
    height: 20px;
    font-size: 14px;
    background: $color_main;
  }

  &:before {
    content: '';
    position: absolute;
    top: auto;
    bottom: auto;
    z-index: 1;
    width: 60%;
    height: 1px;
    background: $border_color;
  }
}
</style>
